<template>
  <div class="loader" :class="bindClass"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    height: {
      type: [Number, String],
      default: 100,
    },
    width: {
      type: [Number, String],
      default: "100%",
    },
    color: {
      type: String,
      default: "rgba(0, 0, 0, 0.12)",
    },
    animation: {
      type: String,
      default: "wave",
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    radius: {
      type: [Number, String],
      default: 0,
    },
    type: {
      type: String,
      default: "rect",
    },
    fill: { type: Boolean, default: false },
  },
  computed: {
    style() {
      return {
        width: typeof this.width === "number" ? `${this.width}px` : this.width,
        height:
          typeof this.height === "number" ? `${this.height}px` : this.height,
        "background-color": `${this.color}`,
        "border-radius": this.rounded ? `${this.radius}px` : 0,
      };
    },
    bindClass() {
      return `animation--${this.animation} shape--${this.type} shape--${
        this.rounded ? "round" : "flat"
      }`;
    },
  },
  mounted() {
    const width =
      typeof this.width === "number" ? `${this.width}px` : this.width;
    const height =
      typeof this.height === "number" ? `${this.height}px` : this.height;
    const background = `${this.color}`;
    const borderRadius = this.rounded ? `${this.radius}px` : 0;

    const loader = this.$el;
    loader.style.setProperty("width", this.fill ? "100%" : width);
    loader.style.setProperty("height", height);
    loader.style.setProperty("background-color", background);
    loader.style.setProperty("border-radius", borderRadius);
  },
});
</script>

<style scoped lang="scss">
.loader {
  overflow: hidden;
  position: relative;
}

.loader::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}

/* Shape stylings */
.shape--text {
  height: 20px;
}

.shape--round {
  border-radius: 8px;
}
</style>
